import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { ShareCommentsPermissions } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/ShareCommentsPermissions";
import { ShareCustomFieldsPermissions } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/ShareCustomFieldsPermissions";
import { ShareSecurityToggles } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/ShareSecurityToggles";
import { ShareVersionsPermissions } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/ShareVersionsPermissions";
export const SharePrivateContentSettings = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, onShortUrlUpdate, isLoading, userPermissions } = param;
    const onPermissionUpdated = useCallback((permissions)=>onShortUrlUpdate({
            permissions
        }), [
        onShortUrlUpdate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-8",
        children: [
            /*#__PURE__*/ _jsx(ShareVersionsPermissions, {
                isLoading: isLoading,
                shortIdInfo: shortIdInfo,
                onPermissionUpdated: onPermissionUpdated,
                canViewAllVersions: userPermissions.asset.canViewAllVersions
            }),
            /*#__PURE__*/ _jsx(ShareCommentsPermissions, {
                isLoading: isLoading,
                shortIdInfo: shortIdInfo,
                onPermissionUpdated: onPermissionUpdated,
                canViewDiscussions: userPermissions.asset.canViewDiscussions,
                canManageDiscussions: userPermissions.asset.canManageDiscussions
            }),
            /*#__PURE__*/ _jsx(ShareCustomFieldsPermissions, {
                isLoading: isLoading,
                shortIdInfo: shortIdInfo,
                onPermissionUpdated: onPermissionUpdated,
                canViewCustomFields: userPermissions.customField.canView,
                canEditCustomFields: userPermissions.customField.canManageApplications
            }),
            /*#__PURE__*/ _jsx(ShareSecurityToggles, {
                isLoading: isLoading,
                shortIdInfo: shortIdInfo,
                onShortUrlUpdate: onShortUrlUpdate
            })
        ]
    });
});
SharePrivateContentSettings.displayName = "SharePrivateContentSettings";
